import { render, staticRenderFns } from "./AddIntent.vue?vue&type=template&id=00be3961&scoped=true&"
import script from "./AddIntent.vue?vue&type=script&lang=js&"
export * from "./AddIntent.vue?vue&type=script&lang=js&"
import style0 from "./AddIntent.vue?vue&type=style&index=0&id=00be3961&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00be3961",
  null
  
)

export default component.exports